import fgInput from '@/components/theme/Inputs/formGroupInput.vue'
import DropDown from '@/components/theme/Dropdown.vue'
import Card from '@/components/theme/Cards/Card.vue'
import {Input, InputNumber} from 'element-ui'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    Vue.component('card', Card)
    Vue.component(Input.name, Input)
    Vue.component(InputNumber.name, InputNumber)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/components/theme/globalComponents.js